export const TRANSLATION_KEY =
  'descriptions.admin-portal.workshops.details.workshop-question';
export const QUESTION_MAX_LENGTH = 300;
